import 'katex/dist/katex.min.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { Provider as JotaiProvider } from 'jotai'
import { queryClientAtom } from 'jotai-tanstack-query'
import { useHydrateAtoms } from 'jotai/react/utils'

import { AppProviders } from '../app/AppProviders'
import { App } from '../app/routes/App/App'
import { queryClient } from '../app/config/queryClient'
import { initDatadog } from '../app/integrations/Datadog'
import { initSentry } from '../app/integrations/Sentry'
import { ThemeProvider as AppThemeProvider } from '@app/ThemeProvider'

import './styles/tailwind.css'

const initializeServices = () => {
  if (import.meta.env.VITE_UI_ENV === 'production') {
    initDatadog()
    initSentry()
  }
}

const HydrateAtoms = ({ children }: { children: React.ReactNode }) => {
  useHydrateAtoms([[queryClientAtom, queryClient]])

  return <>{children}</>
}

const AppRoot = () => {
  React.useEffect(() => {
    initializeServices()
  }, [])

  return (
    <React.StrictMode>
      <AppThemeProvider>
        <QueryClientProvider client={queryClient}>
          <JotaiProvider>
            <HydrateAtoms>
              <AppProviders>
                <App />
              </AppProviders>
            </HydrateAtoms>
          </JotaiProvider>
        </QueryClientProvider>
      </AppThemeProvider>
    </React.StrictMode>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<AppRoot />)
